const zipCodeErrorModals = {
  noServiceState: 'noServiceState',
  noObie: 'noObie',
  noClinicians: 'noClinicians',
};
export default zipCodeErrorModals;
